import {useEffect, useState} from "react";
import {trackPromise} from "react-promise-tracker";
import {getUrl} from "../constants/urls";
import Call from "../service/axiosV2";

export const useHandleCustomFieldsForObject = (objectType, objectId, setCustomFields) => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    const fetchCustomFieldsForObject = async () => {
      const params = {
        app_label: objectType.appLabel,
        model: objectType.model,
        object_id: objectId,
      };
      try {
        const url = getUrl("customFieldsForModel");
        const response = await trackPromise(Call.get(url, {params}));
        setFields(response.data);
        if (setCustomFields) {
          setCustomFields(response.data);
        }
      } catch {
        setFields([]);
        if (setCustomFields) {
          setCustomFields([]);
        }
      }
    };

    fetchCustomFieldsForObject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectId, objectType.appLabel, objectType.model]);

  const generateCustomFieldsPayload = (fields = []) => {
    const arrayOfNameAndValue = fields.map((field) => {
      const {name, type, value} = field;
      let parsedValue = value;
      if (type === "date") {
        if (value && value instanceof Date) {
          const year = value.getFullYear();
          const month = String(value.getMonth() + 1).padStart(2, "0");
          const day = String(value.getDate()).padStart(2, "0");
          parsedValue = `${year}-${month}-${day}`;
        }
      }
      return [name, parsedValue];
    });
    return Object.fromEntries(arrayOfNameAndValue);
  };

  return {fields, generateCustomFieldsPayload};
};
